<template>
    <div class="register-gateway-container">
        <h1>Register New Gateway</h1>
        <form @submit.prevent="registerGateway">
            <div class="form-group">
                <label for="gw_mac">Gateway MAC:</label>
                <input 
                    id="gw_mac" 
                    v-model="gw_mac" 
                    @input="formatMac"
                    placeholder="ex: 64E8336062A6"
                    maxlength="12"
                    required 
                />
            </div>
            <div class="form-group">
                <label for="devicename">Device Name:</label>
                <input id="devicename" v-model="devicename" required />
            </div>
            <div class="form-group">
                <label for="devicelocation">Device Location:</label>
                <input id="devicelocation" v-model="devicelocation" required />
            </div>
            <button type="submit">Register Gateway</button>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            gw_mac: '',
            devicename: '',
            devicelocation: ''
        };
    },
    methods: {
        async registerGateway() {
            try {
                // Step 1: Save gw_mac to gw_info_web
                if (!/^[0-9A-F]{12}$/.test(this.gw_mac)) { alert('Gateway MAC must be 12 hex characters (e.g. 1020BA638E82).'); return; }
                if (!this.devicename || !this.devicelocation) { alert('Device Name and Device Location are required.'); return; }
                await axios.post('/api/registerGateway', {
                    gw_mac: this.gw_mac
                });

                // Wait for 1 second before the second operation
                await new Promise(resolve => setTimeout(resolve, 1000));

                // Step 2: Update gw_recent_web
                await axios.post('/api/updateGatewayInfo', {
                    gw_mac: this.gw_mac,
                    devicename: this.devicename,
                    devicelocation: this.devicelocation
                });

                // Reset form
                this.resetForm();
                alert('Gateway registered successfully!');
            } catch (error) {
                console.error('Failed to register gateway:', error);
                const msg = error?.response?.data?.error || error?.response?.data?.message || error.message;
                alert('Gateway registration failed: ' + msg);
            }
        },
        resetForm() {
            this.gw_mac = '';
            this.devicename = '';
            this.devicelocation = '';
        },
        formatMac() {
            // 콜론을 제거하고 대문자로 변환
            this.gw_mac = this.gw_mac
                .replace(/[^A-Fa-f0-9]/g, '') // 16진수 문자만 허용
                .toUpperCase(); // 대문자로 변환
        }
    }
};
</script>

<style scoped>
.register-gateway-container {
    padding: 20px; /* 상단 패딩을 원래대로 복원 - App.vue에서 전역 처리 */
}

.form-group {
    margin-bottom: 15px;
}

label {
    font-weight: bold;
    display: block;
    margin-bottom: 5px;
}

input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

button {
    padding: 10px 15px;
    background-color: #4e73df;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

button:hover {
    background-color: #2e59d9;
}

.form-group input {
    text-transform: uppercase; /* 입력 시 즉시 대문자로 표시 */
}
</style>
